
Object.defineProperty(exports, "__esModule", {
  value: true
});
var mui = {
  textfield: {
    type: 'TextField',
    map: 'TextField'
  },
  radio: {
    type: 'RadioButtonGroup',
    map: 'Radio',
    options: {
      type: 'RadioButton'
    }
  },
  selectfield: {
    type: 'SelectField',
    map: 'SelectField',
    options: {
      type: 'MenuItem'
    }
  },
  checkbox: {
    type: 'Checkbox',
    map: 'Checkbox',
    options: {
      type: 'Checkbox'
    }
  },
  toggle: {
    type: 'Toggle',
    map: 'Toggle',
    options: {
      type: 'Toggle'
    }
  },
  datepicker: {
    type: 'DatePicker',
    map: 'DatePicker'
  },
  timepicker: {
    type: 'TimePicker',
    map: 'TimePicker'
  },
  autocomplete: {
    type: 'AutoComplete',
    map: 'AutoComplete',
    filter: 'AutoComplete'
  },
  label: {
    type: 'Label',
    map: 'Label'
  }
};

exports.default = mui;